export const VParamsRoutes = {
  COMPANY_ID: "companyId",
  USER_ID: "userId",
};
